import type { Dispatch } from 'redux'
import { connect } from 'react-redux'
import type { RootState } from 'shared/store/reducers'
import { CatalogComponent } from './CatalogComponent'
import {
    allergensSelector,
    catalogSelector,
    fetchCatalog,
    fetchPointsData,
    fetchPrivilegesData,
    selectAllergens,
    toggleWithoutBacon
} from 'shared/store/ecommerce/catalog'
import type { ItemInfos, PurchasableItem } from 'shared/store/ecommerce/order'
import {
    fetchRestaurant,
    priceSelector,
    removeCurrentOrderToken,
    setCartToast,
    setCollectMode,
    setCurrentItemInfos,
    setCurrentSuggestions
} from 'shared/store/ecommerce/order'
import { fetchAvailableFeatures } from 'shared/store/features'
import { push } from 'connected-react-router'
import type { EventMetadata } from 'shared/store/metadata'
import { eventMetadata, pageMetadata } from 'shared/store/metadata'
import type { MetaShortDTO } from 'shared/types'
import { isRestaurantAvailable } from 'shared/store/restaurant'

const mapStateToProps = (state: RootState) => {
    const {
        withoutBacon,
        selectedAllergens,
        operationsRepeat
    } = state.ecommerceCatalogState
    const { authenticated } = state.userState
    const {
        restaurant,
        collectMode,
        isCartToastVisible,
        idsCouponsTemporaryBurned,
        products
    } = state.ecommerceOrderState
    const availableFeatures = state.featuresState.available
    const { search } = state.router.location
    const allergens = allergensSelector(state)
    const catalog = catalogSelector(state)

    const { finalPrice: priceTotal } = priceSelector(state)
    const url = new URLSearchParams(search)
    const restaurantPageUrl = url.get('restaurant')
    const collectModePageUrl = url.get('collectmode')
    const tablePageUrl = url.get('table')
    const terracePageUrl = url.get('terrace') || 'false'
    const tokenPageUrl = url.get('token')

    return {
        coupon:
            state.router.action !== 'POP' &&
            state.router.location?.state?.coupon,
        allergens,
        authenticated,
        catalog,
        operationsRepeat,
        restaurant: restaurant || {},
        collectMode,
        selectedAllergens,
        withoutBacon,
        priceTotal,
        restaurantPageUrl,
        collectModePageUrl:
            collectModePageUrl && collectModePageUrl.toString().toUpperCase(),
        tablePageUrl,
        terracePageUrl,
        tokenPageUrl,
        isCartToastVisible,
        idsCouponsTemporaryBurned,
        products,
        availableFeatures
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    fetchCatalog: (restaurantId: string) => d(fetchCatalog(restaurantId)),
    removeCurrentOrderToken: () => d(removeCurrentOrderToken()),
    selectAllergens: (selectedAllergens: Array<string>) =>
        d(selectAllergens(selectedAllergens)),
    toggleWithoutBacon: () => d(toggleWithoutBacon()),
    setCurrentItemInfos: (itemInfos: ItemInfos) =>
        d(setCurrentItemInfos(itemInfos)),
    setCurrentSuggestions: (suggestions: Array<PurchasableItem>) =>
        d(setCurrentSuggestions(suggestions)),
    isRestaurantAvailable: (restaurantId: string) =>
        d(isRestaurantAvailable(restaurantId)),
    fetchPrivilegesData: () => d(fetchPrivilegesData()),
    fetchPointsPageData: () => d(fetchPointsData()),
    fetchAvailableFeatures: () => d(fetchAvailableFeatures()),
    fetchRestaurant: (pathUrl: string) => d(fetchRestaurant(pathUrl)),
    setCollectMode: (collectMode: string, pickupInfo?: string) =>
        d(setCollectMode(collectMode, pickupInfo)),
    sendMeta: (meta: EventMetadata) => d(eventMetadata(meta)),
    pageMetadata: (payload: MetaShortDTO) => d(pageMetadata(payload)),
    navigate: (to: string) => d(push(to)),
    setCartToast: (isCartToastVisible: boolean) =>
        d(setCartToast(isCartToastVisible))
})

export const Catalog = connect(
    mapStateToProps,
    mapDispatchToProps
)(CatalogComponent)
